<template>
	<div id="kunstraum">
		<!--  Page Header -->
		<header>
			<img class="logo" src="./assets/logo.png" @click="showCard('Home')" />

			<ul class="menu">
				<li>
					<span class='link' style='margin-right: 2rem;' @click="changeZoom(-1)">-</span>
					<span class='link' style='margin-right: 2rem;' @click="changeZoom(1)">+</span>
				</li>

				<li>
					<a href="mailto:pascale.schuerch@kunst-raum.ch">{{ model.getDictionary("main_contact") }}</a>
				</li>

				<li>
					<span class='link' :class="model.getLang() == 'de'? 'lang-active' : ''" @click="setLang('de')">de</span> | 
					<span class='link' :class="model.getLang() == 'en'? 'lang-active' : ''" @click="setLang('en')">en</span> | 
					<span class='link' :class="model.getLang() == 'fr'? 'lang-active' : ''" @click="setLang('fr')">fr</span>
				</li>
			</ul>

			<div v-if="spendenBox" class='spenden'>
				Der virtuelle Kunstraum Wallis ist ein wichtiger Bestandteil für die Bewahrung des Walliser Kulturerbes, der Walliser Kunstszene und der Kunstvermittlung. 
				Der Verein virtueller Kunstraum Wallis bedankt sich herzlich für Ihre Unterstützung! 

				<div class='spenden-action'>
					<div class='spenden-go' @click="showCard('Sponsor')">Zeige Informationen für Sponsoren und Spender</div>
					<div class='spenden-close' @click="spendenBox = false">schliessen</div>
				</div>
			</div>

			<!-- Mobile Navigation Area -->
			<div class='mobile-nav'>
				<div class='mobile-nav-trigger' @click="toggleMobileMenu">&#x2630;</div>
				<div class='mobile-nav-menu navigation darkText' :class="{displayed: mobileNavState}">
					<div class="mobile-nav-close" @click='toggleMobileMenu'>x</div>

					<p class='mobile-lang'>
						<span class='link' style='margin-right: 2rem;' @click="changeZoom(-1)">-</span>
						<span class='link' @click="changeZoom(1)">+</span> <br><br>
						<span class='link' :class="model.getLang() == 'de'? 'lang-active' : ''" @click="setLang('de')">de</span> | 
						<span class='link' :class="model.getLang() == 'en'? 'lang-active' : ''" @click="setLang('en')">en</span> | 
						<span class='link' :class="model.getLang() == 'fr'? 'lang-active' : ''" @click="setLang('fr')">fr</span>
					</p>	

					<div
						:class="activeCard == 'Home'? 'active' : ''"
						class="bg-home link"
						@click="showCard('Home')"
					>{{ model.getDictionary("nav_start") }}</div>
					<div
						:class="activeCard == 'Work'? 'active' : ''"
						class="bg-work link"
						@click="showCard('Work')"
					>{{ model.getDictionary("nav_work") }}</div>
					<div
						:class="activeCard == 'Artist'? 'active' : ''"
						class="bg-artist link"
						@click="showCard('Artist')"
					>{{ model.getDictionary("nav_artist") }}</div>
					<div
						:class="activeCard == 'Collection'? 'active' : ''"
						class="bg-collection link"
						@click="showCard('Collection')"
					>{{ model.getDictionary("nav_collection") }}</div>

					<div
						:class="activeCard == 'Exhibition'? 'active' : ''"
						class="bg-exhibition link"
						@click="showCard('Exhibition')"
					>{{ model.getDictionary("nav_exhibition") }}</div>
					<div
						:class="activeCard == 'Archiv'? 'active' : ''"
						class="bg-archiv link"
						@click="showCard('Archiv')"
					>{{ model.getDictionary("nav_archiv") }}</div>

					<div
						:class="activeCard == 'Tagcloud'? 'active' : ''"
						class="bg-tagcloud link"
						@click="showCard('Tagcloud')"
					>{{ model.getDictionary("nav_tag") }}</div>

					<div
						:class="activeCard == 'Timeline'? 'active' : ''"
						class="bg-timeline link"
						@click="showCard('Timeline')"
					>{{ model.getDictionary("nav_timeline") }}</div>

					<div
						:class="activeCard == 'Game'? 'active' : ''"
						class="bg-timeline link"
						@click="showCard('Game')"
					>{{ model.getDictionary("nav_game") }}</div>

					<div
						:class="activeCard == 'Self'? 'active' : ''"
						class="bg-self font-self link"
						@click="showCard('Self')"
					>{{ model.getDictionary("nav_selection") }}</div>
					<div
						:class="activeCard == 'Cultur'? 'active' : ''"
						class="bg-cultur font-self link"
						@click="showCard('Cultur')"
					>{{ model.getDictionary("nav_cultur") }}</div>
					<div
						:class="activeCard == 'About'? 'active' : ''"
						class="bg-about link"
						@click="showCard('About')"
					>{{ model.getDictionary("nav_aboutus") }}</div>
					<div
						:class="activeCard == 'Link'? 'active' : ''"
						class="bg-links link"
						@click="showCard('Link')"
					>{{ model.getDictionary("nav_link") }}</div>
					<div
						:class="activeCard == 'Sponsor'? 'active' : ''"
						class="bg-sponsor link"
						@click="showCard('Sponsor')"
					>{{ model.getDictionary("nav_sponsor") }}</div>
				</div>
			</div>			

		</header>

		<!--  Page Body Area with Application Content and Navigation  -->
		<div id="body" class="body">
			<transition name="fade" mode="out-in">
				<component
					:is="activeCard"
					:args="args"
					:level="0"
				></component>
			</transition>

			<!--  Navigation Area -->
			<div id="navigation" class="navigation darkText">
				<ul>
					<!--
					<li
						:class="activeCard == 'Home'? 'active' : ''"
						class="bg-home link"
						@click="showCard('Home')"
					>{{ model.getDictionary("nav_start") }}</li>
					-->
					<li
						:class="activeCard == 'Work'? 'active' : ''"
						class="bg-work link"
						@click="showCard('Work')"
					>{{ model.getDictionary("nav_work") }}</li>
					<li
						:class="activeCard == 'Artist'? 'active' : ''"
						class="bg-artist link"
						@click="showCard('Artist')"
					>{{ model.getDictionary("nav_artist") }}</li>
					<li
						:class="activeCard == 'Collection'? 'active' : ''"
						class="bg-collection link"
						@click="showCard('Collection')"
					>{{ model.getDictionary("nav_collection") }}</li>

					<li
						:class="activeCard == 'Exhibition'? 'active' : ''"
						class="bg-exhibition link"
						@click="showCard('Exhibition')"
					>{{ model.getDictionary("nav_exhibition") }}</li>
					<li
						:class="activeCard == 'Archiv'? 'active' : ''"
						class="bg-archiv link"
						@click="showCard('Archiv')"
					>{{ model.getDictionary("nav_archiv") }}</li>

					<li
						:class="activeCard == 'Tagcloud'? 'active' : ''"
						class="bg-tagcloud link"
						@click="showCard('Tagcloud')"
					>{{ model.getDictionary("nav_tag") }}</li>

					<li
						:class="activeCard == 'Timeline'? 'active' : ''"
						class="bg-timeline link"
						@click="showCard('Timeline')"
					>{{ model.getDictionary("nav_timeline") }}</li>

					<li
						:class="activeCard == 'Game'? 'active' : ''"
						class="bg-timeline link"
						@click="showCard('Game')"
					>{{ model.getDictionary("nav_game") }}</li>

					<li
						:class="activeCard == 'Self'? 'active' : ''"
						class="bg-self font-self link"
						@click="showCard('Self')"
					>{{ model.getDictionary("nav_selection") }}</li>

					<li
						:class="activeCard == 'Cultur'? 'active' : ''"
						class="bg-cultur font-self link"
						@click="showCard('Cultur')"
					>{{ model.getDictionary("nav_cultur") }}</li>

					<li
						:class="activeCard == 'About'? 'active' : ''"
						class="bg-about nav-space link"
						@click="showCard('About')"
					>{{ model.getDictionary("nav_aboutus") }}</li>
					<li
						:class="activeCard == 'Link'? 'active' : ''"
						class="bg-links link"
						@click="showCard('Link')"
					>{{ model.getDictionary("nav_link") }}</li>
					<li
						:class="activeCard == 'Sponsor'? 'active' : ''"
						class="bg-sponsor link"
						@click="showCard('Sponsor')"
					>{{ model.getDictionary("nav_sponsor") }}</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

	// import the main components
	import Vue from "vue";
	import Home from "./components/Home.vue";
	import Work from "./components/Work.vue";
	import Artist from "./components/Artist.vue";
	import Collection from "./components/Collection.vue";
	import Exhibition from "./components/Exhibition.vue";
	import Tagcloud from "./components/Tagcloud.vue";
	import Timeline from "./components/Timeline.vue";
	import Game from "./components/Game.vue";
	import Self from "./components/Self.vue";
	import About from "./components/About.vue";
	import Link from "./components/Link.vue";
	import Sponsor from "./components/Sponsor.vue";
	import Archiv from "./components/Archiv.vue";
	import Cultur from "./components/Cultur.vue";
	import Preview from "./components/Preview.vue";

	import { model } from "./model/Model.js";

	export default {
		components: {
			Home,
			Work,
			Artist,
			Collection,
			Exhibition,
			Tagcloud,
			Timeline,
			Game,
			Self,
			About,
			Link,
			Sponsor,
			Archiv,
			Cultur,
			Preview
		},

		data: function() {
			return {
				// spenden box
				spendenBox: true,

				// Mobile Menu State
				mobileNavState: false,
				// Currently active card
				activeCard: "Home",
				// Global preselection term
				args: [],

				model: model
			};
		},

		// Initialization Code
		created: function() {
			// add listener for browser navigation controlls
			let self = this;
			window.onpopstate = function(event) {
				self.popState(event.state);
			}

			// parse initial url
			let url = document.location.href;
			if (url.indexOf("?") != -1) {
				let parameters = url.substring(url.indexOf("?") + 1);
				let terms = parameters.split("/");
				let whiteList = ["Work", "Artist", "Collection", "Exhibition", "Tagcloud", "Timeline", "Self", "About", "Link", "Sponsor", "Archiv", "Cultur", "Preview"];
				if (whiteList.indexOf(terms [0]) != -1) {
					this.activeCard = terms [0];
					this.args = [];
					for (let i = 1; i < terms.length; i++) {
						this.args.push(decodeURI(terms [i]));
					}
				}
			}
		},

		methods: {

			/** Change the Zoom value  */
			changeZoom: function(by) {
				if (by < 0) {
					Vue.prototype.$zoom -= 0.05;
				} else {
					Vue.prototype.$zoom += 0.05;
				}
				window.onresize();
			},

			/** Set the active interface langauge */
			setLang: function(lang) {
				model.setLang(lang);
			},

			/** Pop the State from the history stack (i.e. back operation) */
			popState: function(state) {
				if (state != null) {
					this.args = state.args;
					this.activeCard = state.card;
				}
			},

			/** Store the current state on the history stack */
			pushState: function(card, args) {

				if (typeof card === "undefined" || card == null) {
					card = this.activeCard;
				}
				if (typeof args === "undefined" || args == null) {
					args = this.args;
				}

				let data = {
					args: args,
					card: card
				};

				let url = "?" + card;
				for (let i = 0; i < args.length; i++) {
					url += "/" + encodeURI(args [i]);
				}

				history.pushState(data, "", url);
			},

			/** Switch the active component, with the possibility to apply a filter */
			showCard: function(card, args) {
				this.mobileNavState = false;

				if (typeof args === "undefined" || Array.isArray(args) == false) {
					args = [];
				}

				// update the history
				this.pushState(card, args);

				// update the state
				this.args = args;
				this.activeCard = card;

			},

			toggleMobileMenu: function() {
				this.mobileNavState = !this.mobileNavState;	
			}

		},

		provide: function() {
			return {
				showCard: this.showCard,
				pushState: this.pushState
			}
		}
	};
</script>

<style>

/* Language Selection */
span.lang-active {
	font-weight: bold;
}

p.mobile-lang {
	text-align: center;
	margin-bottom: 2rem;
}

p.mobile-lang span {
	margin-left: 2rem;
	margin-right: 2rem;
}

@media (min-width: 1000px) {

	/************************************************
		Effects
	/************************************************/

	/*	The next three styles define the mouse over zoom effect on images */
	div.zoomable {
		overflow: hidden;
	}

	div.zoomable img {
		transition: transform 7.5s linear;
	}

	div.zoomable:hover img {
		transform: scale(1.25);
	}

	/************************************************
		Page Header Styles - Normal
	/************************************************/

	header {
		position: relative;
		width: 95.6rem;
		padding: 0 0 0 10rem;
		margin: 5rem auto 0 auto;
	}

	header img.logo {
		display: block;
		width: 18.7rem;
		cursor: pointer;
	}

	header ul.menu {
		position: absolute;
		top: 0;
		right: 1rem;
	}

	header ul.menu li {
		list-style: none;
		display: inline;
		padding: 0 0 0 1rem;
	}

	header div.mobile-nav {
		display: none;
	}

	/************************************************
		Page Body
	/************************************************/

	div.body {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
		width: 95.6rem;
		
		margin: 6rem auto;
		padding: 0 0 0 10.2rem;
	}

	div.body div.content {
		width: 66rem;
	}

	div.body div.navigation {
		width: 12rem;
		margin: 0 0 0 6.2rem;
	}

	div.twoColumnLayout {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
	}

	div.body div.columnLeft {
		width: 18.7rem;
		margin: 0 6.2rem 0 0;
	}

	div.body div.columnCenter {
		width: 40.4rem;
		margin-right: 2rem;
	}

	div.content {
		height: 100%;
	}

	div.container {
		position: relative;
	}

	div.bar {
		
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
		
		margin-bottom: 3rem;
	}

	div.bar div {
		padding: 0.4rem 0 0.4rem 2rem;
	}

	.gridLabel {
		width: 20rem;
		margin-right: 2rem;
	}

	.gridDouble {
		width: 20rem;
		margin-right: 2rem;
	}

	.gridTriple {
		width: 31rem;
		margin-right: 2rem;
		margin-left: 11rem;
	}	

}

@media (max-width: 1000px) {

	div.spenden {
		display: none;
	}

	html, body, div#app-wrapper, div#kunstraum {
		height: 100%;
		overscroll-behavior: contain;
	}

	div#kunstraum {
		display: block;
	}

	/************************************************
		Effects
	/************************************************/

	/*	The next three styles define the mouse over zoom effect on images */
	div.zoomable {
		overflow: hidden;
	}

	/************************************************
		Page Header Styles - Normal
	/************************************************/

	header {
		height: 10rem;

		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-between;
		align-items: flex-end;

		position: relative;
		padding: 2rem 3rem;
	}

	header img.logo {
		height: 6rem;
		cursor: pointer;
		z-index: 3;
	}

	header img.logo_bottom {
		display: none;
		width: 50%;
	}

	header ul.menu {
		display: none;
	}

	/************************************************
		Mobile Navigation
	/************************************************/

	header div.mobile-nav {
		display: block;
	}

	header div.mobile-nav-trigger {
		background-color: #FFFFFF;
		position: absolute;
		right: 0rem;
		top: 0rem;
		width: 100%;
		padding: 2rem 3rem 1rem 2rem;

		font-size: 3rem;
		text-align: right;
		z-index: 2;

		cursor: pointer;
	}	

	header div.mobile-nav-menu {
		display: none;

		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;

		z-index: 3;
		background-color: #FFFFFF;

		padding: 4rem 8rem;
		overflow: auto;

		flex-direction: column;
		flex-wrap: none;
		justify-content: space-evenly;
		
	}

	header div.mobile-nav-close {
		text-align: center;
		font-size: 2rem;
		order: 99;
	}

	header div.mobile-nav-menu div {
		height: 2.6rem;
		padding: 0.6rem 2rem 0.6rem 2rem;
		margin: 0 0 1rem 0;
	}

	header div.mobile-nav-menu div.active {
		border-left: 1rem solid #666666;
		padding-left: 1rem !important;
	}

	header div.mobile-nav-menu div:hover {
		border-left: 1rem solid #333333;
		padding-left: 1rem !important;
	}


	header div.displayed {
		display: flex !important;
	}



	/************************************************
		Page Body
	/************************************************/

	div.body {
		height: calc(100% - 10rem);
		padding: 0 3rem 2rem 3rem;
		overflow: auto;
		flex-grow: 1;
	}

	div.body div.navigation {
		display: none;
	}

	div.twoColumnLayout {
		display: flex;
		flex-direction: column-reverse;
		flex-wrap: nowrap;
		justify-content: flex-start;
	}

	div.body div.columnCenter {
		margin-bottom: 4rem;
	}

	div.content {
		height: 100%;
	}

	div.container {
		position: relative;
	}

	div.bar {
		
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		justify-content: flex-start;
		align-items: flex-start;

		margin-bottom: 3rem;
	}

	div.bar div.gridLabel {
		padding: 0.4rem 0 0.4rem 2rem;
		width: 60%;
	}

	div.bar input, div.gridTriple {
		padding: 0.4rem 0 0.4rem 2rem;
		width: 100%;
	}	

}

div.spenden {
	position: absolute;
	right: 1rem;
	bottom: 0rem;
	width: 59.4rem;	
	text-align: justify;
	padding: 1rem 2rem;
	background-color: #d9db9b;
}
div.spenden-action {
	padding-top: 0.5rem;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

div.spenden-action div {
	cursor: pointer;
}

</style>
